import { PageLayout } from '@shared/components/page-layout'
import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { NextPageFC } from '@shared/models/next-fc'
import { PagesPath, pagesTitles } from 'data/pages-titles'
import { GetServerSideProps } from 'next'

import { getTextRecord } from '../admin/http'
import DocumentsMd from '../screens/documents-md'

import { DocumentsMdProps } from './documents-test'

const DocumentsPage: NextPageFC<DocumentsMdProps, PageLayoutOwnProps> = (props) =>
	DocumentsMd(props)

DocumentsPage.layout = PageLayout

DocumentsPage.headProps = {
	title: pagesTitles[PagesPath.documents].title,
	description:
		'Свидетельства и уставные документы ООО «Кредит.Клаб», МКК «Магазин Кредитов», юридическая информация.',
	ogTitle: 'Документы — Credit.Club',
	ogDescription:
		'Свидетельства и уставные документы ООО «Кредит.Клаб», МКК «Магазин Кредитов», юридическая информация.',
}

export const getServerSideProps: GetServerSideProps<DocumentsMdProps> = async () => {
	const docTextRecord = await getTextRecord('DOCUMENTS_KEY')
	return {
		props: {
			textMd: docTextRecord.value,
		},
	}
}

export default DocumentsPage
